"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../index");

var _reactRouterDom = require("react-router-dom");

var _LoginModel = _interopRequireDefault(require("../models/LoginModel"));

var _AuthActions = require("../AuthActions");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LoginPage = /*#__PURE__*/function (_Component) {
  _inherits(LoginPage, _Component);

  _createClass(LoginPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        record: _objectSpread({}, this.state.record, {
          email: '',
          password: '',
          remember: false
        })
      });
    }
    /**
       * Constructor
       *
       * @param props
       */

  }]);

  function LoginPage(props) {
    var _this;

    _classCallCheck(this, LoginPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoginPage).call(this, props)); // Initial state

    _defineProperty(_assertThisInitialized(_this), "formHandler", void 0);

    _this.formHandler = new _index.FormHandler(_assertThisInitialized(_this), new _LoginModel["default"]({
      email: ' ',
      password: ' '
    }), {
      redirect: false
    });

    _this.formHandler.on('submitSuccess', function (data) {
      if (data.success) {
        setTimeout(function () {
          _this.setState({
            redirect: true
          });
        }, 3000);
      }
    });

    return _this;
  }

  _createClass(LoginPage, [{
    key: "onSubmitSuccess",
    value: function onSubmitSuccess(data) {
      if (data.success && data.data.token) {
        this.props.userLoggedIn(data.data.token, data.data.account);
      }
    }
  }, {
    key: "_getModalMessage",
    value: function _getModalMessage(data) {
      if (!data.success) {
        return data.message;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.redirect) {
        return _react["default"].createElement(_reactRouterDom.Redirect, {
          to: "/"
        });
      }

      var formHandler = this.formHandler;
      return _react["default"].createElement("div", {
        className: "public-form-holder"
      }, _react["default"].createElement("h4", null, "SIGN IN"), _react["default"].createElement("div", {
        className: "form-wrapper"
      }, _react["default"].createElement(_index.FormSubmitWrapper, {
        formHandler: formHandler,
        buttonClass: "gold-button",
        to: "/",
        buttonText: "SIGN IN",
        getModalMessage: function getModalMessage(data) {
          return _this2._getModalMessage(data);
        }
      }, _react["default"].createElement("div", {
        className: "login-input-wrapper"
      }, _react["default"].createElement(_index.InputField, {
        className: 'input-group',
        materialProps: {
          fullWidth: true
        },
        autoComplete: this.state.record.email,
        label: "E-mail",
        name: "email" // placeholder={'E-mail'}
        ,
        InputLabelProps: {
          shrink: true
        },
        value: this.state.record.email,
        handler: formHandler
      })), _react["default"].createElement("div", {
        className: "login-input-wrapper"
      }, _react["default"].createElement(_index.InputField, {
        className: 'input-group',
        materialProps: {
          fullWidth: true
        },
        autoComplete: this.state.record.password,
        label: "Password",
        type: "password",
        name: "password" // placeholder={'Password'}
        ,
        InputLabelProps: {
          shrink: true
        },
        value: this.state.record.password,
        handler: formHandler
      }))), _react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          marginTop: 20
        }
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/forgot-password",
        style: {
          color: 'white',
          textDecoration: 'none',
          fontWeight: 'lighter',
          fontSize: 15
        }
      }, " Forgot password? "))));
    }
  }]);

  return LoginPage;
}(_react.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userLoggedIn: function userLoggedIn(token, account) {
      return dispatch((0, _AuthActions.loginTriggerAction)(token, account));
    }
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(LoginPage);

exports["default"] = _default;